import LogoSrc from "../../statics/logo/white/logo-full.svg";
import React from "react";

const Logo = () => {
  return <img src={LogoSrc} alt="Imagine Land Logo" width="100%" />;
};

export default Logo;
